import { Box, Divider } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

const AISourcesSkeletonRow = ({ dataId }: { dataId: string }): JSX.Element => (
  <Box
    display="flex"
    flexDirection="row"
    gap="small"
    data-id={dataId}
    paddingY="small"
  >
    <Skeleton variant="text" width="10%" backgroundColor="light" />
    <Box gap="none" display="flex" flexDirection="column" width="full">
      <Skeleton variant="text" width="30%" backgroundColor="light" />
      <Skeleton variant="text" width="100%" backgroundColor="light" />
      <Skeleton
        variant="text"
        width="100%"
        backgroundColor="light"
        height="20px"
      />
      <Skeleton
        variant="text"
        width="50%"
        backgroundColor="light"
        height="20px"
      />
    </Box>
  </Box>
);

export const AISourcesSkeleton = (): JSX.Element => (
  <Box
    outline
    data-id="ai-sources-skeleton"
    padding="medium"
    borderRadius="medium"
    marginTop="medium"
  >
    <Skeleton variant="text" width="30%" backgroundColor="light" />

    <AISourcesSkeletonRow dataId="ai-sources-skeleton-row-1" />
    <Divider />
    <AISourcesSkeletonRow dataId="ai-sources-skeleton-row-2" />
  </Box>
);
